// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmPopup_ConfirmPopupLayout__oJ1Ag {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
}

.ConfirmPopup_ConfirmPopup__Tamtc {
  position: absolute;
  top: 50%;
  right: 0;
  z-index: 1;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  padding: 15px;
  transform: translateY(-50%);
  border-radius: 5px;
}
.ConfirmPopup_ConfirmPopup__Tamtc .ConfirmPopup_Title__MDElx {
  text-align: center;
  margin: 0 0 5px;
}
.ConfirmPopup_ConfirmPopup__Tamtc .ConfirmPopup_Text__vYYwr {
  text-align: center;
  font-size: 15px;
  line-height: 18px;
  margin: 0 0 15px;
}
.ConfirmPopup_ConfirmPopup__Tamtc .ConfirmPopup_Buttons__ktjDU {
  display: flex;
  column-gap: 10px;
  justify-content: center;
}
.ConfirmPopup_ConfirmPopup__Tamtc .ConfirmPopup_Buttons__ktjDU .ConfirmPopup_Button__roJDz {
  min-width: 100px;
}`, "",{"version":3,"sources":["webpack://./src/components/ConfirmPopup/ConfirmPopup.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AADJ;;AAIA;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,mBCdU;EDeV,yCCjBiB;EDkBjB,aAAA;EACA,2BAAA;EACA,kBAAA;AADJ;AAGI;EACI,kBAAA;EACA,eAAA;AADR;AAII;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAFR;AAKI;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;AAHR;AAKQ;EACI,gBAAA;AAHZ","sourcesContent":["@use '../../variables.scss';\n\n.ConfirmPopupLayout {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1000;\n}\n\n.ConfirmPopup {\n    position: absolute;\n    top: 50%;\n    right: 0;\n    z-index: 1;\n    background: variables.$color-white;\n    box-shadow: variables.$box-shadow-default;\n    padding: 15px;\n    transform: translateY(-50%);\n    border-radius: 5px;\n\n    .Title {\n        text-align: center;\n        margin: 0 0 5px;\n    }\n\n    .Text {\n        text-align: center;\n        font-size: 15px;\n        line-height: 18px;\n        margin: 0 0 15px;\n    }\n\n    .Buttons {\n        display: flex;\n        column-gap: 10px;\n        justify-content: center;\n\n        .Button {\n            min-width: 100px;\n        }\n    }\n}\n","$box-shadow-default: 0 2px 10px rgba(0, 0, 0, 0.5);\n$color-red: #ff0000;\n$color-white: #ffffff;\n$color-blue: #228be6;\n$color-peach: #fff3df;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ConfirmPopupLayout": `ConfirmPopup_ConfirmPopupLayout__oJ1Ag`,
	"ConfirmPopup": `ConfirmPopup_ConfirmPopup__Tamtc`,
	"Title": `ConfirmPopup_Title__MDElx`,
	"Text": `ConfirmPopup_Text__vYYwr`,
	"Buttons": `ConfirmPopup_Buttons__ktjDU`,
	"Button": `ConfirmPopup_Button__roJDz`
};
export default ___CSS_LOADER_EXPORT___;
